import { BASE_URL } from 'config/urls';

import { get, requestSdk } from 'utils/sdk';

export const recentActivity = async (params) =>
  await requestSdk(() => get(`${BASE_URL}/v1/trackers/activity/`, params));
